import { TriggerOption } from '@/components/flow';
import {
  CREATE_AGENT_RUN_FROM_API_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_EMAIL_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_GOOGLE_DRIVE_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_MAKE_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_MANUAL_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_MICROSOFT_ONE_DRIVE_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_N8N_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_POWER_AUTOMATE_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_ZAPIER_FUNCTION_ID,
} from '@/constants';
import { generateId } from '@/utils';

export const TRIGGERS: TriggerOption[] = [
  {
    functionId: CREATE_AGENT_RUN_FROM_MANUAL_FUNCTION_ID,
    config: {},
    name: 'Upload manually',
    description: 'Upload files directly in app. (enabled by default)',
    isFakeImport: true,
  },
  {
    functionId: CREATE_AGENT_RUN_FROM_EMAIL_FUNCTION_ID,
    config: () => ({ email: `${generateId()}@${import.meta.env.VITE_EMAIL_CONNECTORS_DOMAIN}` }),
    name: 'Email',
    description: 'Send files to a dedicated email address.',
  },
  {
    functionId: CREATE_AGENT_RUN_FROM_API_FUNCTION_ID,
    config: () => {},
    name: 'API',
    description: 'Use the Cradl API to send files.',
  },
  {
    functionId: CREATE_AGENT_RUN_FROM_ZAPIER_FUNCTION_ID,
    config: () => {},
    name: 'Zapier',
    description: 'Trigger from a zap.',
  },
  {
    functionId: CREATE_AGENT_RUN_FROM_POWER_AUTOMATE_FUNCTION_ID,
    config: () => {},
    name: 'Power Automate',
    description: 'Trigger from a Power Automate flow.',
  },
  {
    functionId: CREATE_AGENT_RUN_FROM_MAKE_FUNCTION_ID,
    config: {},
    name: 'Make',
    description: 'Trigger from a Make scenario.',
    badge: 'Coming soon',
  },
  {
    functionId: CREATE_AGENT_RUN_FROM_N8N_FUNCTION_ID,
    config: {},
    name: 'n8n',
    description: 'Trigger from a n8n workflow.',
    badge: 'Coming soon',
  },
  {
    functionId: CREATE_AGENT_RUN_FROM_MICROSOFT_ONE_DRIVE_FUNCTION_ID,
    config: {},
    name: 'Microsoft OneDrive',
    description: 'Trigger when a file is added to a folder in OneDrive.',
    badge: 'Coming soon',
  },
  {
    functionId: CREATE_AGENT_RUN_FROM_GOOGLE_DRIVE_FUNCTION_ID,
    config: {},
    name: 'Google Drive',
    description: 'Trigger when a file is added to a folder in Google Drive.',
    badge: 'Coming soon',
  },
];
